import transactionFailure from "../assets/lottie_icons/transaction_failure.json";
import transactionInProgress from "../assets/lottie_icons/transaction_in_progress.json";
import transactionPending from "../assets/lottie_icons/transaction_pending.json";
import transactionSuccess from "../assets/lottie_icons/transaction_success.json";

export type StatusKind = "pending" | "in_progress" | "success" | "failure";

export interface StatusModel {
  iconColor: string;
  bgColor: string;
  statusKind: StatusKind;
  lottieData: object;
}

const PENDING_ICON = {
  iconColor: "text-text-status-yellow",
  bgColor: "bg-bg-status-yellow",
  statusKind: "pending" as const,
  lottieData: transactionPending,
};

const IN_PROGRESS_ICON = {
  iconColor: "text-text-status-yellow",
  bgColor: "bg-bg-status-yellow",
  statusKind: "in_progress" as const,
  lottieData: transactionInProgress,
};

const SUCCESS_ICON = {
  iconColor: "text-text-status-green",
  bgColor: "bg-bg-status-green",
  statusKind: "success" as const,
  lottieData: transactionSuccess,
};

const FAILED_ICON = {
  iconColor: "text-text-status-red",
  bgColor: "bg-bg-status-red",
  statusKind: "failure" as const,
  lottieData: transactionFailure,
};

const DEFAULT_ICON: StatusModel = {
  iconColor: "text-text-base",
  bgColor: "bg-bg-base",
  statusKind: "pending",
  lottieData: transactionPending,
};

const statusMap = new Map<string, StatusModel>([
  ["pending", PENDING_ICON],
  ["completed", SUCCESS_ICON],
  ["confirmed", SUCCESS_ICON],
  ["over payment", SUCCESS_ICON],
  ["under payment", SUCCESS_ICON],
  ["processing", IN_PROGRESS_ICON],
  ["confirmation", IN_PROGRESS_ICON],
  ["waiting", IN_PROGRESS_ICON],
  ["initiated", IN_PROGRESS_ICON],
  ["failed", FAILED_ICON],
  ["cancelled", FAILED_ICON],
  ["system error", FAILED_ICON],
  ["refund processing", IN_PROGRESS_ICON],
  ["refund failed", FAILED_ICON],
  ["refund success", SUCCESS_ICON],
  ["compliance", SUCCESS_ICON],
  ["expired", FAILED_ICON],
  ["insufficient balance", IN_PROGRESS_ICON],
  ["credit", SUCCESS_ICON],
  ["debit", FAILED_ICON],
]);

export function getTransactionStatusIcon(
  transactionStatus?: string,
): StatusModel {
  if (!transactionStatus) return DEFAULT_ICON;

  const status = transactionStatus.toLowerCase().trim();
  return statusMap.get(status) || DEFAULT_ICON;
}

export interface StatusRow {
  label: string;
  value: string;
  statusKey: string;
}

export function getStatusRows(eventId?: number | null): StatusRow[] {
  switch (eventId) {
    case 2:
      return [
        { label: "Order Status", value: "Initiated", statusKey: "initiated" },
      ];
    case 3:
      return [
        { label: "Order Status", value: "Processing", statusKey: "processing" },
      ];
    case 4:
      return [
        { label: "Order Status", value: "Processing", statusKey: "processing" },
      ];
    case 5:
      return [
        { label: "Order Status", value: "Completed", statusKey: "completed" },
      ];
    case 6:
      return [
        {
          label: "Order Status",
          value: "Refund initiated",
          statusKey: "refund processing",
        },
      ];
    case 7:
      return [
        {
          label: "Order Status",
          value: "Refund completed",
          statusKey: "refund success",
        },
      ];
    case 8:
      return [{ label: "Order Status", value: "Failed", statusKey: "failed" }];
    case 9:
      return [
        { label: "Order Status", value: "Cancelled", statusKey: "cancelled" },
      ];
    case 10:
      return [{ label: "Order Status", value: "Failed", statusKey: "failed" }];
    case 11:
      return [
        { label: "Order Status", value: "Pending", statusKey: "pending" },
      ];
    default:
      return [
        { label: "Order Status", value: "Pending", statusKey: "pending" },
      ];
  }
}
